import { render, staticRenderFns } from "./goBack.vue?vue&type=template&id=7287720a&"
import script from "./goBack.vue?vue&type=script&lang=js&"
export * from "./goBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports